export const postLesson = {
  // Rating options
  rating5: 'It was the best!',
  rating4: 'It was good',
  rating3: 'It was okay',
  rating2: 'Not great',
  rating1: 'It was not good',

  // Validation
  validationRating: 'Please select a lesson rating',
  validationNextDate: 'Please enter your preferred next time',
  loginRequired: 'You need to be logged in',

  // Done
  doneTitle: 'Sent!',
  doneBody: 'Thank you for submitting the form.<br />Once your next lesson is scheduled, we will email you again!',
  toMyPage: 'Go to My Page',

  // Header
  heading: 'Post-Lesson Form',
  subtitle: 'Great work! Please share what you learned and your preferences for next time ✨',

  // Sections
  ratingTitle: 'Lesson Rating',
  nextScheduleTitle: 'Preferred Next Time',
  timezoneLabel: 'Time zone: ',
  dateLabel: 'Date',
  timeLabel: 'Time',
  timePlaceholder: 'Select',
  wordPoolTitle: 'Word Pool Phrases',
  wordPoolHelper: 'Enter the phrases you learned in today\'s lesson, one per line (optional). They will be published after admin review.',
  phrasesPlaceholder: 'e.g.:\nOtsukaresama\nNaruhodo\nYoroshiku onegaishimasu',
  notesTitle: 'Notes / Feedback',
  notesPlaceholder: 'Anything you noticed, a message to the team, etc. (optional)',

  // Submit
  submitting: 'Sending...',
  submit: 'Submit form',
};
